export var themes = [
    {
        name: 'default',
        ioMode: {
            dark: {
                primary: {
                    background: '#1e79a5',
                    color: '#075377',
                    borderColor: '#1e79a5',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'red'
                },
                secondary: {
                    background: '#868e96',
                    color: '#5c6873',
                    borderColor: '#868e96',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'white'
                },
                success: {
                    background: '#28a745',
                    color: '#28a745',
                    borderColor: '#28a745',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'green'
                },
                info: {
                    background: '#1997c6',
                    color: '#a7ddf1',
                    borderColor: '#1997c6',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'pink'
                },
                warning: {
                    background: '#fdff00',
                    color: '#ffc107cf',
                    borderColor: '#fdff00',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'blue'
                },
                danger: {
                    background: '#d9534f',
                    color: '#bf2a38',
                    borderColor: '#dc3545',
                    hoverBGColor: '#fdfdfdf7',
                    checkMarkColor: 'grey'
                },
                link: {
                    background: 'blue',
                    color: 'blue',
                    borderColor: 'blue',
                    hoverBGColor: '#fdfdfdf7',
                    panel: 'azure',
                    menubackground: 'blue',
                    menucolor: 'white',
                    menuhoverbgcolor: '#fdfdfdf7',
                    menuhovercolor: ''
                }
            },
            light: {
                primary: {
                    background: '#B33B00',
                    color: '#098194',
                    borderColor: 'antiquewhite',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#e9f7fc',
                    tableHeaderColor: '#20a8d8',
                    tableAccentColor: '#bce6f5',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'red'
                },
                secondary: {
                    background: '#c8ced3',
                    color: '#5c6873',
                    borderColor: '#c8ced3',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid White',
                    tableBackground: '#ffffff',
                    tableHeaderColor: '#394047',
                    tableAccentColor: '#ffffff',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'white'
                },
                success: {
                    background: '#4dbd74',
                    color: '#4dbd74',
                    borderColor: '#4dbd74',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid White',
                    tableBackground: '#ecf8f0',
                    tableHeaderColor: '#30824d',
                    tableAccentColor: '#daf1e2',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'green'
                },
                info: {
                    background: '#004269',
                    color: '#126e84',
                    borderColor: '#004269',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#daf2e6',
                    tableHeaderColor: '#004269',
                    tableAccentColor: '#e6fff2',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'pink'
                },
                warning: {
                    background: '#ffc107c9',
                    color: '#f58828cf',
                    borderColor: '#ffc107c9',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#f2e0aa',
                    tableHeaderColor: '#cc9900',
                    tableAccentColor: '#ffecb3',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'blue'
                },
                danger: {
                    background: '#f86c6b',
                    color: '#dc3545',
                    borderColor: '#f86c6b',
                    hoverBGColor: '#fdfdfdf7',
                    tableBorderColor: '1px solid white',
                    tableBackground: '#fee7e7',
                    tableHeaderColor: '#c30909',
                    tableAccentColor: '#fee7e7',
                    tableHoverColor: '#f2f2f2',
                    checkMarkColor: 'grey'
                },
                link: {
                    background: 'blue',
                    color: 'blue',
                    hoverBGColor: '#fdfdfdf7'
                }
            }
        },
        uiLibrary: 'bootstrap'
    },
    {
        name: 'mugreen',
        ioMode: {
            light: {
                primary: {
                    background: 'green',
                    color: 'white'
                }
            },
            light1: {
                primary: {
                    background: '#6f42c1',
                    color: 'red'
                }
            }
        },
        uiLibrary: 'materialui'
    }
];
export var resolveColor = function (theme, mode, styleName, attribute) {
    return theme.ioMode[mode][styleName ? styleName : 'primary'][attribute];
};
export var resolver = function (enable, theme, mode, styleName, attribute) {
    return enable
        ? theme.ioMode[mode][styleName ? styleName : 'primary'][attribute]
        : '';
};
//# sourceMappingURL=ThemeOptions.js.map